<style>
#TerminalsRegister .v--modal-box.v--modal {
  min-height: 360px !important;
  min-width: 800px !important;
}
#TerminalsRegister .modal__content {
  overflow-y: hidden !important;
}
#TerminalsRegister .modal__footer {
  display: none;
}
#TerminalsRegister .modal__content {
  height: calc(100% - 60px) !important;
}
</style>

<template>
  <Modal
    modalName="TerminalsRegister"
    title="REJESTR PRZYŁĄCZY"
    :buttons=[]
    :register="register"
  >
    <TerminalsTable />
  </Modal>
</template>

<script>
import Modal from "../../../../shared/Modal";
import TerminalsTable from "../../../table/TerminalsTable";

export default {
  components: {
    Modal,
    TerminalsTable
  },
  data: () => ({
    register: true
  }),
  computed: {},
  methods: {}
};
</script>


// WEBPACK FOOTER //
// src/components/viewer/start/modals/terminals/TerminalsRegister.vue